import { ref } from 'vue';
import useApi from '@/composables/useApi.ts';
import useApp from '@/composables/useApp.ts';
import type { Element } from '@/types';

let synced = false;

const recentlyViewed = ref<Element[]>([]);

export default function useRecentlyViewed() {
    const app = useApp();
    const useFetch = useApi();

    if (!synced) {
        recentlyViewed.value = app.recentlyViewed ?? [];
        synced = true;
    }

    async function trackView(
        uid: string,
        type: 'entry' | 'file'
    ): Promise<void> {
        useFetch('track-view').post({ uid, type });
    }

    function getRecentlyViewed(): Element[] {
        return recentlyViewed.value;
    }

    function isRecentlyViewed(uid: string): boolean {
        return recentlyViewed.value.some((item) => item.uid === uid);
    }

    return {
        recentlyViewed,
        trackView,
        getRecentlyViewed,
        isRecentlyViewed,
    };
}
